import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawItemDetail {
  coordinationItems: boolean
  itemRequest: ItemRequest
}

export interface ItemRequest {
  allowAppKind: ItemRequestAppKind[]
}

export type ItemRequestAppKind = 'mail' | 'line'

export class ItemDetail extends AbstractValue<RawItemDetail> {
  get coordinationItems(): boolean {
    return this.raw.coordinationItems
  }

  get itemRequest(): ItemRequest {
    return this.raw.itemRequest
  }
}
